import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebase";
import {
  doc,
  getDoc,
  updateDoc,
  onSnapshot,
  setDoc,
  collection,
  addDoc,
  deleteDoc,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import ServiciosEditor from "./ServiciosEditor";
import DeportistasEditor from "./DeportistasEditor";
import CarruselHomeEditor from "./CarruselHomeAdmin";
import ServiciosDestacadosEditor from "./ServiciosDestacadosEditor";

const BTN_PRIMARY =
  "bg-blue-600 text-white px-6 py-2 rounded-xl font-semibold shadow-sm hover:bg-blue-700 active:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-500/20";

const BTN_SECONDARY =
  "bg-white border border-slate-300 text-slate-700 px-6 py-2 rounded-xl font-semibold hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-slate-500/10";

// =======================================
// CARGAR TODAS LAS IMÁGENES DE /public/fotos
// =======================================
const cargarImagenesPartners = () => {
  try {
    const req = require.context("../../fotos", false, /\.(png|jpe?g|svg)$/);
    return req.keys().map((filename) => ({
      nombre: filename.replace("./", ""),
      ruta: "/fotos/" + filename.replace("./", ""),
    }));
  } catch (e) {
    console.error("Error cargando imágenes de partners:", e);
    return [];
  }
};

const EditarSitio = () => {
  const [tab, setTab] = useState("general"); 
// general | servicios | partners | deportistas | pago | terminos

  // =========================
  // DEPORTISTAS
  // =========================
  const [deportistas, setDeportistas] = useState([]);
  const [deportistasLoading, setDeportistasLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, "deportistas"),
      orderBy("orden", "asc")
    );

    const unsub = onSnapshot(q, (snap) => {
      setDeportistas(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setDeportistasLoading(false);
    });

    return () => unsub();
  }, []);


  // =========================
  // Configuración general
  // =========================
  const [form, setForm] = useState({
    whatsapp: "",
    instagram: "",
    googleMaps: "",
    ubicacion_texto: "",
    horario_texto: "",
    map_embed: "",
    ubicacion_foto: "",
  });

  const [originalData, setOriginalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [fotoUbicacionFile, setFotoUbicacionFile] = useState(null);
  const [subiendoFotoUbicacion, setSubiendoFotoUbicacion] = useState(false);

  const ref = doc(db, "editar_sitio", "config_global");

  // =========================
  // Configuración de pagos
  // =========================
  const [payConfig, setPayConfig] = useState({
    mostrar_linkify: true,
    mostrar_transferencia: true,
    transferencia: {
      nombre: "",
      rut: "",
      banco: "",
      tipo_cuenta: "",
      cuenta: "",
      email: "",
      mensaje: "",
    },
  });


  useEffect(() => {
    const pagosRef = doc(db, "config", "pagos");
    return onSnapshot(pagosRef, async (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setPayConfig({
          mostrar_linkify: data.mostrar_linkify ?? true,
          mostrar_transferencia: data.mostrar_transferencia ?? true,
          transferencia: {
            nombre: data.transferencia?.nombre ?? "",
            rut: data.transferencia?.rut ?? "",
            banco: data.transferencia?.banco ?? "",
            tipo_cuenta: data.transferencia?.tipo_cuenta ?? "",
            cuenta: data.transferencia?.cuenta ?? "",
            email: data.transferencia?.email ?? "",
            mensaje: data.transferencia?.mensaje ?? "",
          },
        });
      } else {
        await setDoc(pagosRef, {
          mostrar_linkify: true,
          mostrar_transferencia: true,
          transferencia: {
            nombre: "",
            rut: "",
            banco: "",
            tipo_cuenta: "",
            cuenta: "",
            email: "",
            mensaje: "",
          },
        });
      }
    });
  }, []);

  // Cargar datos iniciales (información general)
  useEffect(() => {
    async function cargar() {
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setForm(snap.data());
        setOriginalData(snap.data());
      }
      setLoading(false);
    }
    cargar();
  }, []);

  const handleTransferChange = (e) => {
  const { name, value } = e.target; // name: "nombre", "rut", ...
  setPayConfig((prev) => ({
    ...prev,
    transferencia: {
      ...prev.transferencia,
      [name]: value,
    },
  }));
};

const subirFotoUbicacion = async () => {
  if (!fotoUbicacionFile) return form.ubicacion_foto || "";

  try {
    setSubiendoFotoUbicacion(true);

    const extension = fotoUbicacionFile.name.split(".").pop();
    const nombreArchivo = `editar_sitio/ubicacion_${Date.now()}.${extension}`;

    const fileRef = storageRef(storage, nombreArchivo);
    await uploadBytes(fileRef, fotoUbicacionFile);

    const url = await getDownloadURL(fileRef);
    return url;
  } catch (error) {
    console.error("Error subiendo foto de ubicación:", error);
    throw error;
  } finally {
    setSubiendoFotoUbicacion(false);
  }
};

const guardarTransferencia = async () => {
  await updateDoc(doc(db, "config", "pagos"), {
    transferencia: {
      ...payConfig.transferencia,
    },
  });
  alert("Datos de transferencia actualizados ✔");
};

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

const guardar = async () => {
  try {
    let nuevaUrlFoto = form.ubicacion_foto || "";

    if (fotoUbicacionFile) {
      nuevaUrlFoto = await subirFotoUbicacion();
    }

    const payload = {
      ...form,
      ubicacion_foto: nuevaUrlFoto,
    };

    await setDoc(ref, payload, { merge: true });

    setForm(payload);
    setOriginalData(payload);
    setFotoUbicacionFile(null);
    setEditMode(false);

    alert("Datos del sitio actualizados correctamente ✔");
  } catch (error) {
    console.error("Error guardando datos del sitio:", error);
    alert("No se pudieron guardar los cambios.");
  }
};

const cancelar = () => {
  setForm(originalData);
  setFotoUbicacionFile(null);
  setEditMode(false);
};

  // =========================
  // TÉRMINOS Y CONDICIONES
  // =========================
  const terminosRef = doc(db, "config", "terminos");

  const [terminos, setTerminos] = useState({
    titulo_kine: "TÉRMINOS Y CONDICIONES KINESIOLOGÍA, MASAJE Y RECOVERY",
    cuerpo_kine: "",
    titulo_planes: "TÉRMINOS Y CONDICIONES PLANES DE ENTRENAMIENTO",
    cuerpo_planes: "",
    titulo_confidencialidad: "CONFIDENCIALIDAD Y SEGURIDAD DE LA INFORMACIÓN",
    cuerpo_confidencialidad: "",
    nota_general: "",
  });
  const [terminosOriginal, setTerminosOriginal] = useState(null);
  const [terminosLoading, setTerminosLoading] = useState(true);
  const [editModeTerminos, setEditModeTerminos] = useState(false);

  useEffect(() => {
    const cargarTerminos = async () => {
      const snap = await getDoc(terminosRef);
      if (snap.exists()) {
        const loaded = snap.data();
        const merged = { ...terminos, ...loaded }; // ✅ conserva defaults + agrega lo nuevo
        setTerminos(merged);
        setTerminosOriginal(merged);
      } else {
        await setDoc(terminosRef, terminos);
        setTerminosOriginal(terminos);
      }
      setTerminosLoading(false);
    };
    cargarTerminos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTerminosChange = (e) => {
    const { name, value } = e.target;
    setTerminos((t) => ({ ...t, [name]: value }));
  };

  const guardarTerminos = async () => {
    await setDoc(terminosRef, terminos, { merge: true });
    setTerminosOriginal(terminos);
    setEditModeTerminos(false);
    alert("Términos y condiciones actualizados correctamente ✔");
  };

  const cancelarTerminos = () => {
    setTerminos(terminosOriginal);
    setEditModeTerminos(false);
  };

  // =========================
  // PARTNERS / ALIANZAS
  // =========================
  const imagenesPartners = cargarImagenesPartners();
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(true);
  const [partnerForm, setPartnerForm] = useState({
    nombre: "",
    descripcion: "",
    beneficio: "",
    instruccion: "",
    orden: 1,
    activo: true,
    ruta_imagen: "",
  });
  const [editingPartnerId, setEditingPartnerId] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "partners"), orderBy("orden", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setPartners(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setPartnersLoading(false);
    });
    return () => unsub();
  }, []);

  const handlePartnerChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPartnerForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetPartnerForm = () => {
    setPartnerForm({
      nombre: "",
      descripcion: "",
      beneficio: "",
      instruccion: "",
      orden: 1,
      activo: true,
    });
    setEditingPartnerId(null);
  };

  const guardarPartner = async (e) => {
    e.preventDefault();
    const data = {
      ...partnerForm,
      orden: Number(partnerForm.orden) || 1,
      updatedAt: serverTimestamp(),
    };

    if (editingPartnerId) {
      await updateDoc(doc(db, "partners", editingPartnerId), data);
    } else {
      await addDoc(collection(db, "partners"), {
        ...data,
        createdAt: serverTimestamp(),
      });
    }

    resetPartnerForm();
    alert("Partner / alianza guardado correctamente ✔");
  };

  const editarPartner = (p) => {
    setPartnerForm({
      nombre: p.nombre || "",
      descripcion: p.descripcion || "",
      beneficio: p.beneficio || "",
      instruccion: p.instruccion || "",
      orden: p.orden || 1,
      activo: p.activo ?? true,
      ruta_imagen: p.ruta_imagen || "",
    });
    setEditingPartnerId(p.id);
  };

  const eliminarPartner = async (id) => {
    if (!window.confirm("¿Eliminar esta alianza/partner?")) return;
    await deleteDoc(doc(db, "partners", id));
  };

  if (loading) return <div>Cargando configuración...</div>;

  return (
  <div className="min-h-screen bg-slate-100/70 px-4 md:px-8 py-8">
    <div className="max-w-4xl mx-auto space-y-2">
      <h1 className="text-2xl font-bold text-slate-900">Editar Sitio</h1>
        <p className="text-sm text-slate-600">Edita la apariencia y contenido del sitio web.</p>

      {/* ======================= SUBMENÚ DE PESTAÑAS ======================= */}
      <div className="flex gap-2 flex-wrap p-2 bg-white border border-slate-200/70 rounded-2xl shadow-sm">
        {[
          { key: "general", label: "Información general" },
          { key: "servicios", label: "Servicios" },
          { key: "servicios_destacados", label: "Servicios destacados" },
          { key: "partners", label: "Partners / Alianzas" },
          { key: "deportistas", label: "Deportistas" },
          { key: "carrusel_home", label: "Carrusel Inicio" },
          { key: "pago", label: "Pago" },
          { key: "terminos", label: "Términos y Condiciones" },
        ].map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 rounded-full text-sm font-semibold border transition
              ${
                tab === t.key
                  ? "bg-blue-600 text-white border-blue-600 shadow-sm"
                  : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
              }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ======================= PESTAÑA: INFORMACIÓN GENERAL ======================= */}
      {tab === "general" && (
        <div className="bg-white border border-slate-200/70 rounded-2xl shadow-sm p-6 space-y-4">
          <InputField
            label="WhatsApp"
            name="whatsapp"
            value={form.whatsapp}
            onChange={handleChange}
            disabled={!editMode}
          />

          <InputField
            label="Instagram"
            name="instagram"
            value={form.instagram}
            onChange={handleChange}
            disabled={!editMode}
          />

          <InputField
            label="Google Maps Link"
            name="googleMaps"
            value={form.googleMaps}
            onChange={handleChange}
            disabled={!editMode}
          />

          <InputField
            label="Ubicación (texto)"
            name="ubicacion_texto"
            value={form.ubicacion_texto}
            onChange={handleChange}
            disabled={!editMode}
          />

          <InputField
            label="Horario (texto)"
            name="horario_texto"
            value={form.horario_texto}
            onChange={handleChange}
            disabled={!editMode}
          />

          <InputField
            label="Cuadro Mapa Google Maps"
            name="map_embed"
            value={form.map_embed}
            onChange={handleChange}
            disabled={!editMode}
          />

          <div className="space-y-3">
            <label className="block">
              <span className="text-sm font-semibold text-slate-800">
                Foto de ubicación
              </span>

              {(form.ubicacion_foto || fotoUbicacionFile) && (
                <div className="mt-3">
                  <img
                    src={
                      fotoUbicacionFile
                        ? URL.createObjectURL(fotoUbicacionFile)
                        : form.ubicacion_foto
                    }
                    alt="Preview ubicación"
                    className="w-full max-w-xs h-56 object-cover rounded-2xl border border-slate-200 shadow-sm"
                  />
                </div>
              )}

              <input
                type="file"
                accept="image/*"
                disabled={!editMode}
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  setFotoUbicacionFile(file);
                }}
                className={`block w-full mt-3 text-sm ${
                  !editMode ? "opacity-60 cursor-not-allowed" : ""
                }`}
              />
            </label>

            {!!form.ubicacion_foto && !fotoUbicacionFile && (
              <p className="text-xs text-slate-500">
                Ya existe una imagen guardada en la base de datos.
              </p>
            )}
          </div>

          {/* BOTONES */}
          <div className="flex items-center gap-3 pt-4">
            {!editMode ? (
              <button
                onClick={() => setEditMode(true)}
                className={BTN_PRIMARY}
              >
                Editar
              </button>
            ) : (
              <>
                <button
                  onClick={guardar}
                  disabled={subiendoFotoUbicacion}
                  className={`${BTN_PRIMARY} ${subiendoFotoUbicacion ? "opacity-60 cursor-not-allowed" : ""}`}
                >
                  {subiendoFotoUbicacion ? "Subiendo imagen..." : "Guardar cambios"}
                </button>

                <button
                  onClick={cancelar}
                  className={BTN_SECONDARY}
                >
                  Cancelar
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* ======================= PESTAÑA: SERVICIOS ======================= */}
      {tab === "servicios" && (
        <div className="bg-white border border-slate-200/70 rounded-2xl shadow-sm p-6">
          <ServiciosEditor />
        </div>
      )}

      {/* ======================= PESTAÑA: PARTNERS / ALIANZAS ======================= */}
      {tab === "partners" && (
        <div className="bg-white p-6 rounded-xl shadow space-y-4">
          <h2 className="text-xl font-bold text-blue-900 mb-2">
            Alianzas / Partners
          </h2>

          {partnersLoading ? (
            <p>Cargando alianzas...</p>
          ) : (
            <>
              {/* FORMULARIO */}
              <form
                onSubmit={guardarPartner}
                className="bg-slate-50 border border-slate-200/70 rounded-2xl shadow-sm p-4 space-y-3"
              >
                {/* RUTA DE IMAGEN */}
                <label className="block">
                  <span className="font-semibold">Imagen asociada</span>

                  <select
                    name="ruta_imagen"
                    value={partnerForm.ruta_imagen}
                    onChange={handlePartnerChange}
                    className="w-full border rounded-lg p-2 mt-1"
                  >
                    <option value="">-- Selecciona imagen --</option>

                    {imagenesPartners.map((img) => (
                      <option key={img.ruta} value={img.ruta}>
                        {img.nombre}
                      </option>
                    ))}
                  </select>

                  {/* PREVIEW */}
                  {partnerForm.ruta_imagen && (
                    <img
                      src={partnerForm.ruta_imagen}
                      alt="preview"
                      className="mt-2 w-24 h-20 object-cover rounded border"
                    />
                  )}
                </label>
                <InputField
                  label="Nombre del partner / alianza"
                  name="nombre"
                  value={partnerForm.nombre}
                  onChange={handlePartnerChange}
                  disabled={false}
                />

                <TextAreaField
                  label="Descripción"
                  name="descripcion"
                  value={partnerForm.descripcion}
                  onChange={handlePartnerChange}
                  disabled={false}
                />

                <InputField
                  label="Beneficio (ej: Descuento especial en cualquier servicio)"
                  name="beneficio"
                  value={partnerForm.beneficio}
                  onChange={handlePartnerChange}
                  disabled={false}
                />

                <TextAreaField
                  label="Instrucción para el paciente (cómo pedir el cupón, etc.)"
                  name="instruccion"
                  value={partnerForm.instruccion}
                  onChange={handlePartnerChange}
                  disabled={false}
                />

                <div className="grid grid-cols-2 gap-4 items-center">
                  <InputField
                    label="Orden (para el orden de aparición)"
                    name="orden"
                    value={partnerForm.orden}
                    onChange={handlePartnerChange}
                    disabled={false}
                  />

                  <label className="flex items-center gap-2 mt-6">
                    <input
                      type="checkbox"
                      name="activo"
                      checked={partnerForm.activo}
                      onChange={handlePartnerChange}
                    />
                    <span className="text-sm">Activo (visible en la web)</span>
                  </label>
                </div>

                <div className="flex items-center gap-3 pt-2">
                  <button
                    type="submit"
                    className={BTN_PRIMARY}
                  >
                    {editingPartnerId
                      ? "Guardar cambios"
                      : "Crear alianza / partner"}
                  </button>

                  {editingPartnerId && (
                    <button
                      type="button"
                      onClick={resetPartnerForm}
                      className={BTN_SECONDARY}
                    >
                      Cancelar edición
                    </button>
                  )}
                </div>
              </form>

              {/* LISTA DE PARTNERS EXISTENTES */}
              <div className="space-y-2 pt-4">
                {partners.map((p) => (
                  <div
                    key={p.id}
                    className="flex justify-between items-start gap-4 border border-slate-200/70 rounded-2xl p-4 bg-white shadow-sm text-sm"
                  >
                    <div>
                      <p className="font-semibold text-gray-800">
                        {p.nombre}{" "}
                        {!p.activo && (
                          <span className="ml-2 text-xs text-red-500">
                            (inactivo)
                          </span>
                        )}
                      </p>
                      <p className="text-xs text-gray-600">
                        {p.descripcion}
                      </p>
                    </div>
                      {p.ruta_imagen && (
                        <img
                          src={p.ruta_imagen}
                          alt={p.nombre}
                          className="w-20 h-16 object-cover rounded-lg mb-2 border"
                        />
                      )}
                    <div className="flex gap-3">
                      <button
                        type="button"
                        onClick={() => editarPartner(p)}
                        className="text-xs text-blue-600 hover:underline"
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        onClick={() => eliminarPartner(p.id)}
                        className="text-xs text-red-600 hover:underline"
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                ))}

                {!partners.length && (
                  <p className="text-xs text-gray-500">
                    Aún no hay partners creados.
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* ======================= PESTAÑA: DEPORTISTAS ======================= */}
{tab === "deportistas" && (
  <div className="bg-white p-6 rounded-xl shadow">
    <h2 className="text-xl font-bold text-blue-900 mb-4">
      Deportistas
    </h2>
    <DeportistasEditor />
  </div>
)}

{tab === "carrusel_home" && (
  <div className="bg-white border border-slate-200/70 rounded-2xl shadow-sm p-6">
    <CarruselHomeEditor />
  </div>
)}

{tab === "servicios_destacados" && (
  <div className="bg-white border border-slate-200/70 rounded-2xl shadow-sm p-6">
    <h2 className="text-xl font-bold text-blue-900 mb-4">
      Servicios más solicitados
    </h2>
    <ServiciosDestacadosEditor />
  </div>
)}



      {/* ======================= PESTAÑA: PAGO ======================= */}
      {tab === "pago" && (
        <div className="bg-white p-6 rounded-xl shadow space-y-6">
          <h2 className="text-xl font-bold text-blue-900 mb-4">
            Métodos de Pago
          </h2>

          {/* LINKIFY */}
          <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border">
            <div>
              <p className="font-semibold text-gray-800">
                Pagar online con Linkify
              </p>
              <p className="text-sm text-gray-500">
                Habilita o deshabilita el botón de pago online en la agenda.
              </p>
            </div>

            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={payConfig.mostrar_linkify}
                onChange={(e) =>
                  updateDoc(doc(db, "config", "pagos"), {
                    mostrar_linkify: e.target.checked,
                  })
                }
              />

              <div
                className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-blue-600
                              after:absolute after:top-[2px] after:left-[2px]
                              after:w-5 after:h-5 after:bg-white after:rounded-full after:transition-all
                              peer-checked:after:translate-x-5"
              ></div>
            </label>
          </div>

          {/* TRANSFERENCIA */}
          <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border">
            <div>
              <p className="font-semibold text-gray-800">Pago por transferencia</p>
              <p className="text-sm text-gray-500">
                Muestra o esconde la opción de subir comprobante.
              </p>
            </div>

            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={payConfig.mostrar_transferencia}
                onChange={(e) =>
                  updateDoc(doc(db, "config", "pagos"), {
                    mostrar_transferencia: e.target.checked,
                  })
                }
              />

              <div
                className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-blue-600
                              after:absolute after:top-[2px] after:left-[2px]
                              after:w-5 after:h-5 after:bg-white after:rounded-full after:transition-all
                              peer-checked:after:translate-x-5"
              ></div>
            </label>
          </div>
          {payConfig.mostrar_transferencia && (
          <div className="border rounded-xl p-4 bg-white space-y-3">
            <h3 className="font-bold text-blue-900">Datos de Transferencia</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <InputField
                label="Nombre"
                name="nombre"
                value={payConfig.transferencia?.nombre || ""}
                onChange={handleTransferChange}
                disabled={false}
              />
              <InputField
                label="RUT"
                name="rut"
                value={payConfig.transferencia?.rut || ""}
                onChange={handleTransferChange}
                disabled={false}
              />
              <InputField
                label="Banco / App"
                name="banco"
                value={payConfig.transferencia?.banco || ""}
                onChange={handleTransferChange}
                disabled={false}
              />
              <InputField
                label="Tipo de cuenta (Vista, Corriente, etc.)"
                name="tipo_cuenta"
                value={payConfig.transferencia?.tipo_cuenta || ""}
                onChange={handleTransferChange}
                disabled={false}
              />
              <InputField
                label="N° de cuenta"
                name="cuenta"
                value={payConfig.transferencia?.cuenta || ""}
                onChange={handleTransferChange}
                disabled={false}
              />
              <InputField
                label="Email"
                name="email"
                value={payConfig.transferencia?.email || ""}
                onChange={handleTransferChange}
                disabled={false}
              />
            </div>

            <TextAreaField
              label="Mensaje opcional"
              name="mensaje"
              value={payConfig.transferencia?.mensaje || ""}
              onChange={handleTransferChange}
              disabled={false}
            />

            <div className="flex justify-end pt-2">
              <button
                onClick={guardarTransferencia}
                className={BTN_PRIMARY}
              >
                Guardar datos de transferencia
              </button>
            </div>
          </div>
        )}

        </div>
      )}

      {/* ======================= PESTAÑA: TÉRMINOS ======================= */}
      {tab === "terminos" && (
        <div className="bg-white p-6 rounded-xl shadow space-y-4">
          <h2 className="text-xl font-bold text-blue-900 mb-2">
            Términos y Condiciones
          </h2>

          {terminosLoading ? (
            <p>Cargando términos...</p>
          ) : (
            <>
              <InputField
                label="Título Kinesiología / Masaje / Recovery"
                name="titulo_kine"
                value={terminos.titulo_kine}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <TextAreaField
                label="Texto Kinesiología / Masaje / Recovery"
                name="cuerpo_kine"
                value={terminos.cuerpo_kine}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <InputField
                label="Título Planes de Entrenamiento"
                name="titulo_planes"
                value={terminos.titulo_planes}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <TextAreaField
                label="Texto Planes de Entrenamiento"
                name="cuerpo_planes"
                value={terminos.cuerpo_planes}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <InputField
                label="Título Confidencialidad y Seguridad"
                name="titulo_confidencialidad"
                value={terminos.titulo_confidencialidad}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <TextAreaField
                label="Texto Confidencialidad y Seguridad"
                name="cuerpo_confidencialidad"
                value={terminos.cuerpo_confidencialidad}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <TextAreaField
                label="Nota general / texto final (opcional)"
                name="nota_general"
                value={terminos.nota_general}
                onChange={handleTerminosChange}
                disabled={!editModeTerminos}
              />

              <div className="flex items-center gap-3 pt-4">
                {!editModeTerminos ? (
                  <button
                    onClick={() => setEditModeTerminos(true)}
                    className={BTN_PRIMARY}
                  >
                    Editar
                  </button>
                ) : (
                  <>
                    <button
                      onClick={guardarTerminos}
                      className={BTN_PRIMARY}
                    >
                      Guardar términos
                    </button>

                    <button
                      onClick={cancelarTerminos}
                      className={BTN_SECONDARY}
                    >
                      Cancelar
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  </div>
  );
};

const fieldBase =
  "w-full bg-white border border-slate-300 rounded-xl px-3 py-2 mt-1 text-sm " +
  "placeholder:text-slate-400 " +
  "hover:border-slate-400 " +
  "focus:outline-none focus:ring-4 focus:ring-blue-500/15 focus:border-blue-500";

const InputField = ({ label, name, value, onChange, disabled }) => (
  <label className="block">
    <span className="text-sm font-semibold text-slate-800">{label}</span>
    <input
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`${fieldBase} ${disabled ? "bg-slate-100 text-slate-500 cursor-not-allowed" : ""}`}
    />
  </label>
);

const TextAreaField = ({ label, name, value, onChange, disabled }) => (
  <label className="block">
    <span className="text-sm font-semibold text-slate-800">{label}</span>
    <textarea
      name={name}
      rows={5}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`${fieldBase} resize-y ${disabled ? "bg-slate-100 text-slate-500 cursor-not-allowed" : ""}`}
    />
  </label>
);


export default EditarSitio;
